export class Label {
    id = "";
    name = {it: ""};
}
